import Authorization from '../Authorization';

export default class BaseFlowAuthorization extends Authorization {
    constructor() {
        super();
        this.setAuthorizedUserStates(['ANONYMOUS', 'EX_SUBSCRIBER']);
        this.setRegionsToInclude(['us']);
    }
    testAllowed(): boolean {
        return super.testAllowed();
    }
}
